import React from 'react';
import Lottie from 'react-lottie-player';

import * as animacao from './aprender.json';

const Aprender = (): React.ReactElement => {
  return (
    <Lottie loop play animationData={animacao} style={{ width: '100%' }} />
  );
};

export default Aprender;
